import { Badge } from '@/components/v2/ui'

interface Props {
  n: number
}

export function SlotNumberBadge({ n }: Props) {
  return (
    <Badge variant="primary" className="absolute top-2 right-2">
      #{n}
    </Badge>
  )
}
